import { render } from "./BrandNjuskalo.vue?vue&type=template&id=7e69b3fb"
import script from "./BrandNjuskalo.vue?vue&type=script&lang=ts"
export * from "./BrandNjuskalo.vue?vue&type=script&lang=ts"

import "./BrandNjuskalo.vue?vue&type=style&index=0&id=7e69b3fb&lang=scss"
script.render = render

export default script